export enum TokenType {
    ACCESS_TOKEN = 1,
    REFRESH_TOKEN = 2
}